export class TranslateStaticFilters {
  static readonly type = '[Static Filters] Translate intervals';
  constructor() {}
}
